export function parseNumericTabletId(value: string | number | null | undefined): number | null {
  if (value == null) {
    return null;
  }
  const n = typeof value === 'number' ? value : Number.parseInt(String(value), 10);
  return Number.isFinite(n) ? n : null;
}
